import actionTypes from '../constants/action-types';

const enable = () => ({
  type: actionTypes.ENABLE,
});

export default enable;
